import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

/* Lazy load as these bot lists fall over every all the time */
const BotListWidgets = () => (
  <React.Fragment>
    <h2 className="due-landing__heading">We're listed!</h2>
    <div id="landing-wigets">
      <a href="https://botsfordiscord.com/bots/213271889760616449" >
        <LazyLoadImage src="https://botsfordiscord.com/api/bot/213271889760616449/widget?theme=dark"
          title="Support DueUtil on Bots for Discord!"
          alt="Bots for Discord widget failed to load!"/>
      </a>
      <a href="https://bots.ondiscord.xyz/bots/213271889760616449">
        <LazyLoadImage src="https://bots.ondiscord.xyz/bots/213271889760616449/embed?theme=dark"
        alt="Bots on Discord widget failed to load!" />
      </a>
      <a href="https://top.gg/bot/213271889760616449" >
        <LazyLoadImage src="https://top.gg/api/widget/213271889760616449.svg"
          title="Support DueUtil on top.gg!"
          alt="top.gg widget failed to load!" />
      </a>
    </div>
  </React.Fragment>)

export default BotListWidgets;
